import {generateChatId} from "./utils";
import {createChat} from "../API/chatAPI";

export const handleCreateChat = ({chatMessages, navigateToChat, setKBChats}) => {
    const chatId = generateChatId();
    const lastMsg = chatMessages[chatMessages.length - 1];
    const title = lastMsg?.content?.split?.(" ").slice(0, 5).join(" ")
    navigateToChat(chatId);
    setKBChats(prev => [{title, chatId, isPlaceholder: true}, ...(Array.isArray(prev) ? prev : [])]);
    createChat(title, chatMessages, chatId)
}